import { render, staticRenderFns } from "./MisPolizasColaborador.vue?vue&type=template&id=25b19930&"
import script from "./MisPolizasColaborador.vue?vue&type=script&lang=js&"
export * from "./MisPolizasColaborador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports